import { useState, useEffect } from "react";
import { X } from "lucide-react";

const AvisoDiarioModal = () => {
  const [aviso, setAviso] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [avisoId, setAvisoId] = useState(null); 

  const idUsuario = localStorage.getItem("idUsuario"); 

  useEffect(() => {
    const fetchAviso = async () => {
      try {
        const response = await fetch("https://sismoney.com/painel/aviso.php?acao=buscar");
        console.log("Resposta do servidor:", response);

        if (response.ok) {
          const data = await response.json();

          if (data) {
            data.forEach(x => {
              if (x.ativo == 1) {
                const visto = x.idVisto ? JSON.parse(x.idVisto) : [];
                if (!visto.includes(idUsuario)) {
                  setAviso(x.mensagem);
                  setAvisoId(x.id); 
                  setIsOpen(true);
                }
              }
            });
          } else {
            console.error("Resposta vazia do servidor.");
          }
        } else {
          console.error("Erro no servidor:", response.status);
        }
      } catch (error) {
        console.error("Erro ao buscar aviso diário:", error);
      }
    };

    fetchAviso();
  }, []);

  const handleFecharAviso = async () => {
    try {
      if (idUsuario && avisoId) {
        const response = await fetch("https://sismoney.com/painel/aviso.php", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: avisoId,
            idUsuario: idUsuario,
          }),
        });

        const result = await response.json();
        if (result.success) {
          console.log("Aviso marcado como visto");
        } else {
          console.error("Erro ao marcar aviso como visto:", result.message);
        }
      }
    } catch (error) {
      console.error("Erro ao registrar aviso visto:", error);
    }

    setIsOpen(false);
  };

  if (!isOpen || !aviso) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-96 text-center">
        <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100">Aviso</h2>
        <p className="mt-2 text-gray-700 dark:text-gray-300">{aviso}</p>
        <button
          onClick={handleFecharAviso} 
          className="mt-4 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  );
};

export default AvisoDiarioModal;
